import React from 'react';

function FullLayout({ children }) {
  return (
    <div className="flex flex-col py-6 mx-20 max-sm:mx-2 justify-center">
      {children}
    </div>
  );
}

export default FullLayout;
